import { useContext, type FunctionComponent } from 'react';
import { Button } from '@fff-web/fff-ui-shared';
import ButtonAction from '../../interfaces/buttonAction';
import { SurveyPageContext } from '../context/SurveyPageContext';
import * as styles from './NavigationFooter.module.css';

type OwnProps = {
  backButton: ButtonAction;
  nextButton: ButtonAction;
};

const NavigationFooter: FunctionComponent<OwnProps> = ({ backButton, nextButton }) => {
  const { surveyPage, firstBackButtonAction } = useContext(SurveyPageContext);

  const showBackButton = surveyPage !== 1 || firstBackButtonAction;
  const backButtonComponent = (
    <div className={styles.backButton}>
      <Button onClick={backButton.onClick} disabled={nextButton.disabled} variation="black-outline">
        {backButton.label}
      </Button>
    </div>
  );

  return (
    <div className={styles.navigationFooterContainer} data-testid="navigation-footer">
      {showBackButton ? backButtonComponent : ''}
      <div className={styles.nextButton}>
        <Button onClick={nextButton.onClick} disabled={nextButton.disabled}>
          {nextButton.label}
        </Button>
      </div>
    </div>
  );
};

export default NavigationFooter;
